// src/services/Contact.js

import api from "../api/axiosConfig";

// ----------------------
// SEND CONTACT FORM
// ----------------------
export const sendContactForm = async (formData) => {
  try {
    // Convert frontend fields to match your Django model fields
    const payload = {
      title: formData.name,               // required by model
      slug: formData.name.toLowerCase().replace(/\s+/g, "-"),
      fullName: formData.name,
      email: formData.email,
      phone: formData.phone,
      property: convertProperty(formData.propertyType),
      message: formData.message || "",
    };

    const response = await api.post("contact/", payload);

    return {
      success: true,
      data: response.data
    };

  } catch (error) {
    return {
      success: false,
      message: error.response?.data || "Something went wrong",
    };
  }
};

// Converts React dropdown value → Django choices
const convertProperty = (value) => {
  switch (value) {
    case "Studio":
      return "studio";
    case "1 Bed":
      return "1_bed";
    case "2 Bed":
      return "2_bed";
    default:
      return null;
  }
};
